var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.34 3.51L11.29 1.07C10.63 0.54 9.8 0.25 8.95 0.25H4C1.93 0.25 0.25 1.93 0.25 4V16C0.25 18.07 1.93 19.75 4 19.75H12C14.07 19.75 15.75 18.07 15.75 16V6.44C15.75 5.29 15.24 4.23 14.34 3.51ZM13.4 4.68C13.6 4.84 13.76 5.04 13.89 5.24H10C9.86 5.24 9.75 5.13 9.75 4.99V1.99C9.75 1.99 9.73 1.92 9.73 1.88C9.95 1.96 10.17 2.08 10.35 2.23L13.4 4.67V4.68ZM11.99 18.24H4C2.76 18.24 1.75 17.23 1.75 15.99V4C1.75 2.76 2.76 1.75 4 1.75H8.3C8.27 1.83 8.25 1.91 8.25 2V5C8.25 5.96 9.04 6.75 10 6.75H14C14.09 6.75 14.17 6.73 14.25 6.7V16C14.25 17.24 13.24 18.25 12 18.25L11.99 18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.88439 13.1342C6.99376 13.2435 7.13229 13.2946 7.27082 13.2946C7.40935 13.2946 7.54789 13.2435 7.65725 13.1342L9.11548 11.6759L10.5737 10.2177C10.7852 10.0063 10.7852 9.65628 10.5737 9.44484C10.3623 9.23339 10.0123 9.23339 9.80085 9.44484L7.27082 11.9749L6.19902 10.9031C5.98758 10.6916 5.6376 10.6916 5.42616 10.9031C5.21472 11.1145 5.21472 11.4645 5.42616 11.6759L6.88439 13.1342Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploaded);
export default __webpack_public_path__ + "static/media/file-uploaded.fead8a702b31cfda25e0a9767ea98d98.svg";
export { ForwardRef as ReactComponent };